// Typed time values for the date & time picker: "1:03 PM", "1:03pm", "1 pm",
// "13:03", "1303" and "9" (9:00 AM) are all accepted.

export interface ITimeOfDay {
  hours: number;
  minutes: number;
}

const STEP_MINUTES = 30;

/** "12:00 AM" … "11:30 PM" every 30 minutes. */
export const TIME_OPTIONS: string[] = Array.from(
  { length: (24 * 60) / STEP_MINUTES },
  (_, i) => formatTime({ hours: Math.floor((i * STEP_MINUTES) / 60), minutes: (i * STEP_MINUTES) % 60 })
);

export function parseTime(text: string): ITimeOfDay | null {
  const value = (text || '').trim().toLowerCase().replace(/\./g, '');
  const match = value.match(/^(\d{1,2})(?::?(\d{2}))?\s*(a|p|am|pm)?$/);
  if (!match) return null;

  let hours = Number(match[1]);
  const minutes = match[2] ? Number(match[2]) : 0;
  const meridiem = match[3]?.[0];
  if (minutes > 59) return null;

  if (meridiem) {
    if (hours < 1 || hours > 12) return null;
    hours = (hours % 12) + (meridiem === 'p' ? 12 : 0);
  } else if (hours > 23) {
    return null;
  }
  return { hours, minutes };
}

export function formatTime({ hours, minutes }: ITimeOfDay): string {
  const suffix = hours >= 12 ? 'PM' : 'AM';
  return `${hours % 12 || 12}:${String(minutes).padStart(2, '0')} ${suffix}`;
}

/** Options that start with what was typed (spaces and case ignored); all of them when nothing is typed. */
export function filterTimeOptions(typed: string): string[] {
  const needle = normalize(typed);
  return needle ? TIME_OPTIONS.filter((option) => normalize(option).startsWith(needle)) : TIME_OPTIONS;
}

/** Index of the option at or just before a time, to scroll the list to it. */
export function closestTimeOptionIndex({ hours, minutes }: ITimeOfDay): number {
  return Math.floor((hours * 60 + minutes) / STEP_MINUTES);
}

function normalize(value: string): string {
  return (value || '').toLowerCase().replace(/[\s.]/g, '');
}
